module.exports = __webpack_public_path__ + "media/images/task_12_2020-7bd5d8d0f05ec683d5b78784c27b3de6.png";